import api from "@/api/education";
import {
  STATUS_TEST_PASSED
} from "@/constants/categories";

export default {
  state: {
    categories: null,
    course: null,
    exam: null,
    examResults: null,
    courseStartedAt: null,
    courses: null
  },
  getters: {
    getCategories: state =>
      state.categories &&
      state.categories.sort(function (a, b) {
        return a.sort > b.sort ? 1 : a.sort < b.sort ? -1 : 0;
      }),
    getCourse: state => state.course,
    getExam: state => state.exam,
    getCurrentCategory: state => id =>
      state.categories &&
      state.categories.filter(category => category.id == id)[0],
    getExamQuestions: state => state.exam && state.exam.questions,
    getCurrentExamQuestion: state => (chunkIndex, questionIndex) =>
      state.exam &&
      state.exam.questions[Object.keys(state.exam.questions)[chunkIndex]][
        questionIndex
      ],
    getCurrentExamQuestionsChunkKey: state => id =>
      state.exam && +Object.keys(state.exam.questions)[id],
    getExamQuestionsTotalCount: state =>
      state.exam &&
      Object.values(state.exam.questions).reduce((a, b) => {
        return +a + b.length;
      }, 0),
    getExamResults: state => state.examResults,
    getExamAttempts: state => state.exam && state.exam.additional.attempts,
    getExamErrorsCount: state =>
      state.examResults && state.examResults.errors_count,
    getExamTestPassed: state =>
      state.examResults && state.examResults.test_passed,
    getIsProductExamPassed: state => id =>
      state.categories &&
      state.categories.filter(category => category.id == id)[0].status === STATUS_TEST_PASSED,
    getCourses: state => state.courses,
    getCourseAttributes: state => {
      if (!state.course) return;

      const {
        components
      } = state.course;
      return [{
          key: components.volume,
          value: components.format
        },
        {
          key: components.country,
          value: components.additional_information
        }
      ];
    }
  },
  mutations: {
    SET_CATEGORIES_DATA(state, payload) {
      state.categories = payload;
    },
    SET_COURSE_DATA(state, payload) {
      state.course = payload;
    },
    SET_EXAM_DATA(state, payload) {
      state.exam = payload;
    },
    SET_EXAM_RESULTS(state, payload) {
      state.examResults = payload;
    },
    SET_COURSE_STARTED_AT(state, payload) {
      state.courseStartedAt = payload;
    },
    SET_COURSES_DATA(state, payload) {
      state.courses = payload;
    },
    CLEAR_EXAM_RESULT(state) {
      state.examResults = null;
    }
  },
  actions: {
    async fetchCategories({
      commit
    }) {
      try {
        const response = await api.getCategories();
        const {
          data: {
            data: {
              categories
            }
          },
          status
        } = response;

        if (status === 200) {
          commit("SET_CATEGORIES_DATA", categories);
        }

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error.response.data.data);
      }
    },
    fetchCourse({
      commit
    }, payload) {
      api
        .getCourseById(payload)
        .then(({
          data: {
            data: {
              item
            }
          },
          status
        }) => {
          if (status === 200) {
            commit("SET_COURSE_DATA", item);
          }
        });
    },
    fetchExam({
      commit,
      dispatch
    }, payload) {
      commit('CLEAR_EXAM_RESULT');
      dispatch("setIsLoadingData", true);
      api
        .getExam(payload)
        .then(({
          data: {
            data
          },
          status
        }) => {
          if (status === 200) {
            commit("SET_EXAM_DATA", data);
          }
        })
        .finally(() => {
          dispatch("setIsLoadingData", false);
        });
    },
    postExam({
      commit,
      dispatch
    }, payload) {
      dispatch("setIsLoadingData", true);
      api
        .saveExam(payload)
        .then(({
          data: {
            data: {
              answers
            }
          }
        }) => {
          commit("SET_EXAM_RESULTS", answers);
        })
        .finally(() => {
          dispatch("setIsLoadingData", false);
        });
    },
    async beginEducation({
      commit
    }, payload) {
      const result = await api
        .beginEducation(payload)
        .then(({
          data: {
            data: {
              category: {
                started_at
              }
            }
          }
        }) => {
          commit("SET_COURSE_STARTED_AT", started_at);
        })
        .catch(e => {
          const {
            education
          } = e.response.data.data.messages;

          throw education;
        });

      return result;
    }
  }
};